import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=52ac3b87&"
import script from "./auth.vue?vue&type=script&lang=ts&"
export * from "./auth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ThemeToggle: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/global/ThemeToggle.vue').default,ButtonTertiary: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/buttons/ButtonTertiary.vue').default})
